import { render } from "./Campaign.vue?vue&type=template&id=3c4d1cf3&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3c4d1cf3"

export default script